import React from "react";
import { Navigate } from "react-router-dom";
import PageNotFound from "pages/PageNotFound";

function AuthWrapper({ children, isPrivate, isAdmin, path }) {
  const userAuth = JSON.parse(localStorage.getItem("setstate_quiz"));

  if (!userAuth) {
    return <Navigate to={`/login?urlReturn=${path ?? "/"}`} />;
  }

  if (isPrivate === true && (!userAuth || userAuth.authenticated === false)) {
    return <Navigate to={`/login?urlReturn=${path ?? "/"}`} />;
  }

  if (
    isAdmin === true &&
    (!userAuth ||
      userAuth.authenticated === false ||
      !(userAuth.roles.includes("Dev") || userAuth.roles.includes("Admin")))
  ) {
    return <PageNotFound />;
  }

  return children;
}

export default AuthWrapper;
